"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createProductCategoryFilter = exports.createCollaboratorFilter = exports.createFloatFilter = exports.createIntFilter = exports.createDateTimeFilter = exports.createExternalIdFilter = exports.createStringFilter = void 0;
const graphql_1 = require("../../../__generated__/graphql");
const ui_components_1 = require("@groupby/ui-components");
const utils_1 = require("./utils");
const createStringFilter = ({ search, match = ui_components_1.MatchOptions.Include, operator: filterOperator, }, operator = filterOperator) => (Object.assign({ mode: graphql_1.StringFilterMode.Insensitive }, (operator === ui_components_1.TextFilterOperatorTypes.NotEquals ? {
    notIn: [search],
} : match === ui_components_1.MatchOptions.Include ? {
    contains: search,
} : {
    not: {
        contains: search,
    },
})));
exports.createStringFilter = createStringFilter;
/**
 * Creates a StringFilter for Product ID (ExternalId) field.
 * Supports both single-value (Contains) and multi-value (IsAnyOf) filtering.
 * For IsAnyOf operator, splits input by comma and/or whitespace.
 *
 * @param filter - The table column text filter
 * @param operator - The filter operator type
 * @returns StringFilter for GraphQL query, or undefined if empty
 */
const createExternalIdFilter = (filter, operator) => {
    const { search } = filter;
    // If operator is IsAnyOf, parse comma/whitespace-separated values and use 'in' array
    if (operator === ui_components_1.TextFilterOperatorTypes.IsAnyOf) {
        const values = (0, utils_1.parseSeparatedValues)(search, [',', ' ']);
        // Return undefined if no valid values (don't apply filter)
        if (values.length === 0) {
            return undefined;
        }
        return {
            mode: graphql_1.StringFilterMode.Insensitive,
            in: values,
        };
    }
    if (operator === ui_components_1.TextFilterOperatorTypes.NotEquals) {
        return {
            mode: graphql_1.StringFilterMode.Insensitive,
            notIn: [search],
        };
    }
    // Fallback to regular string filter for other operators (Contains, etc.)
    return (0, exports.createStringFilter)(filter, operator);
};
exports.createExternalIdFilter = createExternalIdFilter;
const createDateTimeFilter = ({ startAt, endAt }) => (Object.assign(Object.assign({}, startAt && { gte: new Date(startAt).toISOString() }), endAt && { lte: new Date(endAt).toISOString() }));
exports.createDateTimeFilter = createDateTimeFilter;
const createIntFilter = ({ low, high, operator }) => {
    const exactValue = low !== null && low !== void 0 ? low : high;
    switch (operator) {
        case ui_components_1.NumberFilterOperatorTypes.Equal:
            return exactValue != null ? { equals: Number(exactValue) } : {};
        case ui_components_1.NumberFilterOperatorTypes.NotEqual:
            return exactValue != null ? { notIn: [Number(exactValue)] } : {};
        case ui_components_1.NumberFilterOperatorTypes.GreaterThanOrEqual:
            return low != null ? { gte: Number(low) } : {};
        case ui_components_1.NumberFilterOperatorTypes.LessThanOrEqual:
            return high != null ? { lte: Number(high) } : {};
        default:
            return Object.assign(Object.assign({}, low != null && { gte: Number(low) }), high != null && { lte: Number(high) });
    }
};
exports.createIntFilter = createIntFilter;
exports.createFloatFilter = exports.createIntFilter;
const createCollaboratorFilter = (filter, operator) => ({
    name: (0, exports.createStringFilter)(filter, operator),
});
exports.createCollaboratorFilter = createCollaboratorFilter;
const createProductCategoryFilter = (filter, operator) => ({
    categories: {
        some: {
            category: (0, exports.createStringFilter)(filter, operator),
        },
    },
});
exports.createProductCategoryFilter = createProductCategoryFilter;
